module.exports = __webpack_public_path__ + "img/w3_dropship_black.eeea4049.png";